export default __webpack_public_path__ + "static/media/GTL Dark.31916272.svg";